import React, {useState, useEffect} from 'react';
import Cleave from "cleave.js/react";
import error from '../autorizacaoGuias/images/archive.png'
import DocumentoService from '../../../../services/documento-service'


const SolicitacaoDeDocumentos = (props) => {
    const [nome, setNome] = useState("")
    const [telefone, setTelefone] = useState("")
    const [email, setEmail] = useState("")
    const [documento, setDocumento] = useState("")
    const [mensagem, setMensagem] = useState("")
    const [loading, setLoading] = useState(false)
    const [didError, setDidError] = useState (false)
    const [errorsForm, setErrorsForm] = useState([])
    const [success, setSuccess] = useState(false)

    useEffect(() => {
      window.parent.postMessage('change', window.location.origin)
    });
  

    const renderValidation = (field) =>{
        const error = errorsForm.filter(e=>e.field === field)
        if (!error.length){
            return null
        }
        return (<div className="validation-message">{error[0].message}</div>)
    }

    const renderSuccess = () =>{
        if(success){
            return <div className="success"><p>Solicitação enviada com sucesso</p></div>
        }

    }

    const renderError = () => {
        if (didError) {
          return (
            <div className="not-found-wrapper">
              <img src={error} alt="Erro" />
              <h5>Ocorreu um erro</h5>
              <p>
                Um erro ocorreu ao processar sua consulta. Por favor tente
                novamente.
              </p>
              <p>
                Se esta mensagem for recorrente, entre em contato com o suporte.
              </p>
            </div>
          );
        }
        return null;
      };
 
    const sendData = async () => {
            const errors =[]
            if (validateForm()) {
              return;
            }
            setLoading(true);
            const res = await DocumentoService.sendSolicitacao(nome, telefone, email, documento, mensagem);
            setLoading(false);
            if (!res.error) {
              setSuccess(true);
            }
            else{
              
              if (res.info === "Dados enviados incompletos.") {
                errors.push({ field: "form", message: "Verifique seus dados" });
              }
              setDidError(true);
            }
            setErrorsForm(errors);
    }

    const validateForm = ()=>{
        const errors = []
        if(nome.length === 0){
            errors.push({field: 'nome',message: 'Preencha seu nome'})
        }
        if(telefone.length < 10 ){
            errors.push({field:"telefone",message:"Verifique o telefone e o DDD"})
        }

        if(email.length === 0){
            errors.push({field:"email",message:"Preencha o seu email"})
        }
        
        if(documento === ""){
            errors.push({field:"documento",message:"Escolha uma opção"})
        }
        
        if(mensagem === ""){
            errors.push({field:"menssagem",message:"Preencha esse campo"})
        }
        setErrorsForm(errors)
        return errors.length
    }


    return (
        <section className={`consulta-copart txt8 lh-1 ${props.hide ? 'hide' : ''}`}>
          <h2 className="txt-laranja ">Solicitação de documentos</h2>
					<h3 className="txt-verde">Informe os campos abaixo</h3>
					<div className="box-passos">
							<div className="linha-form"><div>Nome:</div><div> <input type="text"id="carteira" name="carteira" value={nome} onChange={e=>setNome(e.target.value)}/> {renderValidation("nome")}</div></div>
                           
							<div className="linha-form"><div>Telefone:</div><div><Cleave type="tel"   options={{blocks: [2, 5, 4],delimiters: [" ", "-"],numericOnly: true}} onChange={e=>setTelefone(e.target.value)} /> {renderValidation("telefone")} </div></div>
							<div className="linha-form"><div>Email:</div><div> <input id="email" type="email" name="email" value={email} onChange={e=>setEmail(e.target.value)}/> {renderValidation("email")}</div></div>
                           
                            <div className="linha-form"><div>Documento:</div> <div>
                            <select id="documentos" name="documentos" value={documento} onChange={e=>setDocumento(e.target.value)}>
                                <option value=""> </option>
                                <option value="Boletim/Prontuário de Atendimento">Boletim/Prontuário de Atendimento</option>
                                <option value="Carta de Carências">Carta de Carências</option> 
                                <option value="Contrato">Contrato</option> 
                                <option value="Declarações">Declarações</option> 
                            </select>
                            {renderValidation("documento")}</div></div>
                            <div className="linha-form"><div>Mensagem:</div><div> <textarea id="mensagem" name="mensagem" value={mensagem} onChange={e=>setMensagem(e.target.value)}/> {renderValidation("menssagem")}</div></div>
							<div className="linha-form"><div></div><div><button disabled={success} className="btn" onClick={() => sendData()}>Enviar</button></div></div>
                            {loading  ? 
                            <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                            : null }
                            {renderError()}
                            {renderSuccess()}

					</div>
				</section>
    )
};

export default SolicitacaoDeDocumentos;